export enum Mode {
  VIEW = "VIEW",
  EDIT = "EDIT",
}

export interface ModeBasedString {
  view: string;
  edit?: string;
}
